import React, { useState, useEffect, useRef } from 'react';

const LaunchplanItem = ({
  project,
  handleOpenModal,
  fetchProject,
  isSelected,
  onSelectChange,
  renameProject
}) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [renameInputVisible, setRenameInputVisible] = useState(false);
  const [renameInput, setRenameInput] = useState('');

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const renameInputRef = useRef(null);

  const handleDropdownToggle = () => {
    setIsDropdownVisible((prevState) => !prevState);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isDropdownVisible &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [isDropdownVisible]);

  // Close rename input when clicking outside
  useEffect(() => {
    const handleClickOutsideInput = (event) => {
      if (
        renameInputVisible &&
        renameInputRef.current &&
        !renameInputRef.current.contains(event.target)
      ) {
        setRenameInputVisible(false);
        setRenameInput('');
      }
    };

    document.addEventListener('mousedown', handleClickOutsideInput);
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideInput);
    };
  }, [renameInputVisible]);

  // Focus on rename input when it becomes visible
  useEffect(() => {
    if (renameInputVisible && renameInputRef.current) {
      renameInputRef.current.focus();
    }
  }, [renameInputVisible]);

  // Date formatting
  const dateParts = project.post_date.split(' ')[0].split('-');
  const formattedDate = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
  const fuseNumber = project.fuse_list ? project.fuse_list.length : 0;

  // Action handlers
  const handleOpenRename = () => {
    setIsDropdownVisible(false);
    setRenameInputVisible(true);
  };

  const handleCompare = () => {
    // Implement compare functionality
    handleOpenModal('compare', project.fuse_list);
    setIsDropdownVisible(false);
  };

  const handleDelete = () => {
    // Implement delete functionality
    handleOpenModal('deleteProject', project);
    setIsDropdownVisible(false);
  };

  const handleRenameProjectTitle = () => {
    if (renameInput.trim() === '') {
      // Optionally handle empty input
      return;
    }
    project.project_name = renameInput;
    setRenameInputVisible(false);
    setRenameInput('');
    renameProject(project.ID, renameInput);
  };

  return (
    <div
      className={`fuselight-dashboard-list-item ${
        project.isDeleting ? 'fade-out' : ''
      }`}
    >
      <div className="fuselight-dashboard-item-checkbox">
        <label className="custom-checkbox">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelectChange}
            aria-label={`Select Launchplan ${project.brand_name}`}
          />
          <span></span>
        </label>
      </div>
      {renameInputVisible && (
        <input
          className="rename-input"
          type="text"
          ref={renameInputRef}
          value={renameInput}
          onChange={(e) => setRenameInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleRenameProjectTitle();
            }
          }}
        />
      )}
      <div className="project-info" onClick={() => fetchProject(project)}>
        <p>
          {project.project_name ? project.project_name : project.brand_name}
        </p>
        <p>
          <span className="fuse-number">{fuseNumber}</span>
        </p>
        <p>{formattedDate}</p>
      </div>
      <div className="dropdown-container">
        <button className="dots" onClick={handleDropdownToggle} ref={buttonRef}>
          <div></div>
          <div></div>
          <div></div>
        </button>
        {isDropdownVisible && (
          <div className="dropdown-menu" ref={dropdownRef}>
            <button className="dropdown-item" onClick={handleOpenRename}>
              Rename
            </button>
            {project.fuse_list && project.fuse_list.length > 1 && (
              <button className="dropdown-item" onClick={handleCompare}>
                Compare
              </button>
            )}
            <button className="dropdown-item" onClick={handleDelete}>
              Delete
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LaunchplanItem;
